import { createContext } from 'react';
var AnalyticsNextContext = createContext({
  getAtlaskitAnalyticsContext: function getAtlaskitAnalyticsContext() {
    return [];
  },
  getAtlaskitAnalyticsEventHandlers: function getAtlaskitAnalyticsEventHandlers() {
    return [];
  }
});
export default AnalyticsNextContext;